import { useState } from 'react';
import { Search } from 'lucide-react';

/** Publisher / imprint enum row from the catalog API */
export interface EnumPickRow {
  _id: string;
  key: string;
  value: string;
}

export function EnumPickList({
  items,
  selectedIds,
  onToggle,
  emptyHint,
  filterPlaceholder,
}: {
  items: EnumPickRow[];
  selectedIds: string[];
  onToggle: (id: string) => void;
  emptyHint?: string;
  filterPlaceholder?: string;
}) {
  const [q, setQ] = useState('');
  const ql = q.trim().toLowerCase();
  const filtered =
    ql === ''
      ? items
      : items.filter(
          (r) =>
            r.value.toLowerCase().includes(ql) ||
            r.key.toLowerCase().includes(ql) ||
            r._id.toLowerCase().includes(ql),
        );

  return (
    <div>
      <div className="relative mb-2">
        <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={filterPlaceholder ?? 'Filter by label…'}
          className="w-full pl-8 pr-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-500"
        />
      </div>
      <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-lg p-2 space-y-0.5">
        {filtered.map((row) => (
          <label
            key={row._id}
            className="flex items-start gap-2 cursor-pointer py-1 px-1 rounded hover:bg-gray-50"
          >
            <input
              type="checkbox"
              checked={selectedIds.includes(row._id)}
              onChange={() => onToggle(row._id)}
              className="rounded border-gray-300 text-brand-600 focus:ring-brand-500 mt-0.5 shrink-0"
            />
            <span className="min-w-0 flex-1">
              <span className="text-sm text-gray-900 block leading-snug">{row.value}</span>
              {row.key ? (
                <span className="text-[11px] text-gray-400 font-mono leading-tight block">{row.key}</span>
              ) : null}
            </span>
          </label>
        ))}
        {filtered.length === 0 && (
          <p className="text-sm text-gray-400 py-3 text-center">{emptyHint ?? 'No matches'}</p>
        )}
      </div>
    </div>
  );
}
